// extracted by mini-css-extract-plugin
module.exports = {"SurveyTest":"Survey_SurveyTest__3Q2AX","Questions":"Survey_Questions__7H9yM","Question":"Survey_Question__1C331","QuestionTextarea":"Survey_QuestionTextarea__3wI0u"};